
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 19a2.006 2.006 0 002 2h8a2.006 2.006 0 002-2V9a2.006 2.006 0 00-2-2H8a2.006 2.006 0 00-2 2v10zM18 4h-2.5l-.71-.71a1.009 1.009 0 00-.7-.29H9.91a1.009 1.009 0 00-.7.29L8.5 4H6a1 1 0 100 2h12a1 1 0 000-2z"}})])
          )
        }
      }
    